'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorTextFields = function EditorTextFields(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M2.5 4v3h5v12h3V7h5V4h-13zm19 5h-9v3h3v7h3v-7h3V9z' })
  );
};
EditorTextFields = (0, _pure2.default)(EditorTextFields);
EditorTextFields.displayName = 'EditorTextFields';
EditorTextFields.muiName = 'SvgIcon';

exports.default = EditorTextFields;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/svg-icons/editor/text-fields.js
// module id = 2988
// module chunks = 0